import { useElementSize } from '@vueuse/core'
import { computed, unref } from 'vue'
/**
 * Given an element ref, returns a computed style object containing its height in
 * pxels in order to comply with the given aspect ratio.
 *
 * @param {Node} el the element that needs aspect ratio applied
 * @param {string|number|import('node_modules/@vue/reactivity/dist/reactivity').Ref<string>|import('node_modules/@vue/reactivity/dist/reactivity').Ref<number>} aspect a number or a string with a sintax like w:h, w/h or w-h
 * @returns {Object} a style object with a height that matches the given aspect ratio
 */
export const useAspectRatio = (el, aspect) => {
  /**
   * decodes aspect ratio input (string or number)
   */
  const decodedAspectRatio = computed(() => {
    const ar = unref(aspect)
    if (typeof ar === 'string') {
      let spl = ar.split(':')

      if (spl.length !== 2) {
        spl = ar.split('/')
      }

      if (spl.length !== 2) {
        spl = ar.split('-')
      }
      if (spl && spl.length === 2) {
        return parseFloat(spl[0]) / parseFloat(spl[1])
      } else {
        throw new Error('Cannot decode aspect ratio, use a sintax like w:h, w/h or w-h')
      }
    } else if (typeof ar === 'number') {
      return ar
    }
    return null
  })

  const { width } = useElementSize(el)
  /**
   * returns the computed property
   */
  return computed(() => {
    if (decodedAspectRatio.value === undefined || decodedAspectRatio.value === null) {
      throw new Error('Cannot decode aspect ratio, use a number or a string with a sintax like w:h, w/h or w-h')
    }
    return {
      height: `${width.value / decodedAspectRatio.value}px`
    }
  })
}
